import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { CreationDateSortOptions, LocalStorageKeys, TransitPurchaseOrderColumnHeader } from "src/enums";
import { TransitPurchaseOrdersFilters } from "src/types";

class TransitPurchaseOrderDashService extends DashboardService<
  TransitPurchaseOrderColumnHeader,
  TransitPurchaseOrdersFilters,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.TRANSIT_PURCHASE_ORDER_DASH_SETTINGS);
  }
}

export { TransitPurchaseOrderDashService };
